import type { SupportedLocale } from './locale.ts';

export interface LocaleUrlState {
  readonly replace: (locale: SupportedLocale) => void;
}

interface BrowserLocaleUrlEnvironment {
  readonly history: {
    readonly state?: unknown;
    readonly replaceState: (data: unknown, unused: string, url?: string | URL | null) => void;
  };
  readonly location: Pick<Location, 'href'>;
}

export function createLocaleUrl(currentHref: string, locale: SupportedLocale): string {
  const url = new URL(currentHref);
  url.searchParams.set('lang', locale);
  return url.href;
}

export function createBrowserLocaleUrlState(
  environment: BrowserLocaleUrlEnvironment,
): LocaleUrlState {
  return Object.freeze({
    replace(locale: SupportedLocale): void {
      environment.history.replaceState(
        environment.history.state ?? null,
        '',
        createLocaleUrl(environment.location.href, locale),
      );
    },
  });
}
